'use client';

import { AppImageClient, AppImageData } from '@/shared/components/appImage';
import { Button } from '@/shared/components/button';
import { useGetClientHost } from '@/shared/hooks';
import { isRuDomain as _isRuDomain } from '@/shared/utils/getDomainInfo';

interface Tab {
  chipsContent: string[];
  buttonName: string;
  buttonHref: string;
  secondButtonName?: string;
  secondButtonHref?: string;
}

export const TabsDataCard = ({
  tab,
  imageData,
}: {
  tab: Tab;
  /** Данные AppImage для картинки таба, подготовленные на сервере через `getAppImageData` с теми же width/height. */
  imageData: AppImageData;
}) => {
  const isRuDomain = _isRuDomain(useGetClientHost());

  return (
    <div className="bg-surface-base-secondary flex w-full items-center justify-between gap-1 rounded-t-xl rounded-b-3xl px-14 py-12 max-md:relative max-md:mt-[170px] max-md:flex-col max-md:px-4 max-md:py-4">
      <div className="flex w-[40%] flex-wrap gap-x-4 gap-y-5 max-md:z-20 max-md:w-full max-md:pt-[70px]">
        {tab.chipsContent.map((chip) => (
          <div
            key={chip}
            className="text-text-base-secondary flex h-fit items-center rounded-[40px] bg-[image:var(--chip-linear-gradient)] px-6 py-[10px] backdrop-blur-[40px]"
          >
            {chip}
          </div>
        ))}
      </div>
      <div className="w-1/2 max-md:flex max-md:w-full max-md:items-center max-md:justify-center max-md:pt-4 md:relative">
        <AppImageClient
          {...imageData}
          alt=""
          width={527}
          height={425}
          className="h-full object-cover max-md:absolute max-md:top-[-150px] max-md:h-fit max-md:w-[90%]"
        />
        <div className="flex w-full flex-col justify-center gap-3 max-md:w-full md:absolute md:bottom-2 md:left-1/2 md:-translate-x-1/2 md:flex-row">
          {isRuDomain && tab.secondButtonName && tab.secondButtonHref && (
            <Button
              variant="secondary"
              href={tab.secondButtonHref}
              target="_blank"
              className="max-md:w-full max-md:justify-center"
              ariaLabel={tab.secondButtonName}
            >
              {tab.secondButtonName}
            </Button>
          )}
          <Button
            variant="secondary"
            href={tab.buttonHref}
            target="_blank"
            className="max-md:w-full max-md:justify-center"
            ariaLabel={tab.buttonName}
          >
            {tab.buttonName}
          </Button>
        </div>
      </div>
    </div>
  );
};
